import axios from 'axios';

import { Item } from 'types/items';
import { Site } from 'types/site';

const URL = `${process.env.REACT_APP_API_URL}`;

const NGROK_HEADERS = {
  'ngrok-skip-browser-warning': 'true',
};

/**
 * Public (unauthenticated) QR lookups deliberately use raw axios — the shared
 * `api` instance redirects to /login on any 401, which would break scanners.
 */

export const fetchItemByQrCode = async (qrCode: string): Promise<Item> => {
  const { data } = await axios.get(`${URL}/item/by-qr-code`, {
    params: { qrCode },
    headers: NGROK_HEADERS,
  });

  return data?.item as Item;
};

export const fetchLocationForQr = async (locationId: string): Promise<Site> => {
  const { data } = await axios.get(`${URL}/location/qr/${locationId}`, {
    headers: NGROK_HEADERS,
  });

  return data?.item as Site;
};

export const recordQrScan = async (payload: {
  qrCode: string;
  venueId: string;
}): Promise<void> => {
  await axios.post(`${URL}/qr-code`, payload, {
    headers: NGROK_HEADERS,
  });
};
